export const subtitles = {
    "1": {
        "startTime": 0.309,
        "endTime": 12.659,
        "transcript": "Au͡g'umek tua-i Alussistuamek qaillun, qaillun nallunriqarraallerpeceńek [?]yugallerpeni una wani cikiqengyaraq qaillun alerquutekellruatgu?",
        "translation": "About Christmas from before, when you first learned about it when you were [?growing], what instructions did they give about generosity?"
    },
    "2": {
        "startTime": 12.781,
        "endTime": 20.701,
        "transcript": "Avani au͡gkut ciuqliput nepaitellruut. Nepaitellruut.",
        "translation": "Back then, our ancestors were peaceful. They were peaceful."
    },
    "3": {
        "startTime": 20.772,
        "endTime": 27.902,
        "transcript": "Tua-i waten ciulirnemeggnek qanrutesterluteng, inerqurterluteng, ayuqucirturterluteng.",
        "translation": "They had their elders like this to instruct them, admonish them, and advise them."
    },
    "4": {
        "startTime": 27.914,
        "endTime": 36.304,
        "transcript": "Cali-llu waten tukuullrunritut avani ciuqvani. Canek-llu makunek Kass'artarnek teguqerrartevkenateng.",
        "translation": "Also, they weren't wealthy a long time ago. And these Western things weren't on hand."
    },
    "5": {
        "startTime": 36.314,
        "endTime": 42.924,
        "transcript": "Tua-i waten ilateng piilnguut ikayurluki, tua-i alerquutekluku. Tuaten ayuqellruut.",
        "translation": "They would help those around them who didn't have anything, as was traditionally instructed. That's what they were like."
    },
    "6": {
        "startTime": 42.938,
        "endTime": 54.528,
        "transcript": "Cali piilnguut waten tangerrluki piilutaitnek ikayurluki, navrilluki cali piilnguut. Tuaten ayuqellruut yuut au͡gkut angullrenka.",
        "translation": "Also, they helped those who didn't have anything by looking at what they didn't have, and also lent them things. That's what the people I was born in time to see were like."
    },
    "7": {
        "startTime": 55.347,
        "endTime": 63.577,
        "transcript": "Tua-i-llu man'a waten castailnguq iciw' tua-i elliraat makut, aipainret pinarquciicetun tua-i ikayurluki.",
        "translation": "Then one who didn't have a provider liket his, you know, these orphans, widows, they helped them with whatever they needed."
    },
    "8": {
        "startTime": 63.581,
        "endTime": 67.681,
        "transcript": "Ikayualuki akinaullerkameggnek pivkenateng.",
        "translation": "They helped them without expecting payment."
    },
    "9": {
        "startTime": 67.698,
        "endTime": 71.428,
        "transcript": "Tamana-am akinaullerkaq inerquutekluku-am cali.",
        "translation": "They also admonished against expecting payment."
    },
    "10": {
        "startTime": 71.484,
        "endTime": 77.434,
        "transcript": "Waten pisqevkenaki: \"Uum, uum akinaurniaraanga. Waten pilaku.\" Tuaten pisqevkenaku.",
        "translation": "They told them not to do this: \"This person may reward me. Let me do this.\" They said not to do that."
    },
    "11": {
        "startTime": 77.445,
        "endTime": 83.875,
        "transcript": "Tau͡gaam tua-i waten akinaunra umyuaqevkenaku ikayurluki ilateng arenqiallugtellriit.",
        "translation": "Instead, without thinking of payment like this, help those who are in misfortune around them."
    },
    "12": {
        "startTime": 83.881,
        "endTime": 87.891,
        "transcript": "Kevgailnguut kevgarturluki. Tuaten ayuqellruut yuut.",
        "translation": "Seeve those who have no helpers. That's what people were like."
    },
    "13": {
        "startTime": 87.968,
        "endTime": 97.068,
        "transcript": "Camek tamana wani kangingqerrniaqluku akilircetaarpek'naki canrituq, kiik' ikayurluku. Camek kangililallruatgu?",
        "translation": "What did they say was the meaning of being okay without payment, but to go ahead and help? What meaning did they prescribe to it?"
    },
    "14": {
        "startTime": 97.567,
        "endTime": 102.007,
        "transcript": "Waten kangililallruat: tua-i-gguq tamaa-i tamana kingukegtuq.",
        "translation": "They prescribed this meaning to it: that has good aftereffects [later in life]."
    },
    "15": {
        "startTime": 102.79,
        "endTime": 112.774,
        "transcript": "Iciw' akqutmek, akqutmek niicuitukut avani. Akeqnerrlugutmek-llu niicuunata.",
        "translation": "You know, we didn't hear promises back then. And we didn't hear threats."
    },
    "16": {
        "startTime": 113.909,
        "endTime": 116.099,
        "transcript": "Tuaten ayuqellruut yuut.",
        "translation": "That's what people were like."
    },
    "17": {
        "startTime": 116.605,
        "endTime": 126.415,
        "transcript": "Qaillun-mi pitariluten elpet, qaillun tayim' pitariluten Alussistuamek niiteqarraallrusit? Qaillun-llu pillrusit Alussistua[?].",
        "translation": "So, how old were you, how old were you when you first heard about Christmas? And what did you do [?] Christmas?"
    },
    "18": {
        "startTime": 126.421,
        "endTime": 132.301,
        "transcript": "Alussistuamek tua-i niitelangukut wangkuta. Qaneryaramek tua-i niitelangukut.",
        "translation": "We started hearing about Christmas. We started hearing the Bible."
    },
    "19": {
        "startTime": 132.312,
        "endTime": 139.522,
        "transcript": "Qaneryariurteḿek tua-i cali nalluluteng tua-i, tau͡gaam tua-i niitaqluteng, niitelangluteng.",
        "translation": "And they also didn't know of preachers, but they would hear of them, started hearing of them."
    },
    "20": {
        "startTime": 139.532,
        "endTime": 147.302,
        "transcript": "Caqaameng tua-i piinanermeggni tua-i qaneryariurta tekicaurrluni.",
        "translation": "And one day, eventually, a preacher started arriving."
    },
    "21": {
        "startTime": 150.136,
        "endTime": 155.676,
        "transcript": "Qaillun-mi elpet Alussistuaq piqarraallrani elpet qaillun...",
        "translation": "So, when Christmas first start, how did you..."
    },
    "22": {
        "startTime": 155.686,
        "endTime": 162.026,
        "transcript": "Alussistuaq tua-i piqarraallranek ayagnillranek tau͡gaam tua-i niitelangluta.",
        "translation": "We only started hearing of the first Christmas and when it began."
    },
    "23": {
        "startTime": 162.029,
        "endTime": 174.559,
        "transcript": "Tua-i-ll' Alussistuaryaurrluteng iciw' tua-i tuyumek cikiumiimeng ugkut nunallret tayima Qinarmiullret wiinga ellangvikellrenka.",
        "translation": "Then they started having Christmas, you know, when they were given a pastor downriver in the old village of Qinarmiut where I grew up."
    },
    "24": {
        "startTime": 175.37,
        "endTime": 182.7,
        "transcript": "Tuyumek cikiumiimeng taum tua-i Alussistuaq takumni piyaurcetellrua.",
        "translation": "When they were given a pastor, he started the Christmas tradition in my life."
    },
    "25": {
        "startTime": 183.041,
        "endTime": 184.791,
        "transcript": "Qaillun pivkaraqluci?",
        "translation": "What would [s]he have you do?"
    },
    "26": {
        "startTime": 184.804,
        "endTime": 192.584,
        "transcript": "Tua-i Alussistuaq maa-i tua-i atulauciacetun makutgun Qaneryaratgun aturaqluku.",
        "translation": "They'd celebrate Christmas as they do now, celebrating as told in this Bible."
    },
    "27": {
        "startTime": 192.59,
        "endTime": 199.76,
        "transcript": "Tua-i cikiqaquuraulluteng-llu tua-i piaqluteng iciw' tua-i cali carrluarnek tua-i.",
        "translation": "And they would give each other things, you know, including little things."
    },
    "28": {
        "startTime": 199.774,
        "endTime": 203.704,
        "transcript": "Waten ayuqellrunritut yuut avani ciuqvaarni.",
        "translation": "People weren't like this a long time ago."
    },
    "29": {
        "startTime": 203.709,
        "endTime": 207.539,
        "transcript": "Qaneryaraq-llu man'a alaillrani waten ayuqsugnaitellruut.",
        "translation": "And when this Bible appeared, they were absolutely nothing like this."
    },
    "30": {
        "startTime": 207.541,
        "endTime": 216.111,
        "transcript": "Canek tau͡gaam tua-i cikiqaquuraulluteng. Neqerrluarnek tuaten cikiqaquuraulluteng tua-i pinaurtut.",
        "translation": "Instead, they'd give each other things. They'd even give each other smoked dried fish."
    },
    "31": {
        "startTime": 216.787,
        "endTime": 221.457,
        "transcript": "Kass'artarmek piitellermeggni neqet avatiitni canek-llu cikiqengaqluteng?",
        "translation": "When they didn't have Western things, what else would they give aside from food?"
    },
    "32": {
        "startTime": 221.465,
        "endTime": 225.525,
        "transcript": "Tua-i-wa neqnek, neqnek tua-i.",
        "translation": "Well, food, [they'd give] food."
    },
    "33": {
        "startTime": 226.446,
        "endTime": 234.406,
        "transcript": "Cali-ll' piilnguut pikalget tua-i carrluarnek tua-i cikiqaqluki pitullruit.",
        "translation": "Also, for those without anything, those who had [something to spare] would give them some little things."
    },
    "34": {
        "startTime": 239.69,
        "endTime": 244.24,
        "transcript": "(Aturpagayuunateng-qaa camek nalluluteng?) Aturpagayuunateng-wa.",
        "translation": "(Would they not sing because they didn't know?) They wouldn't sing."
    },
    "35": {
        "startTime": 244.253,
        "endTime": 254.723,
        "transcript": "Tau͡gaam iciw' ingularcuutnek-am cali quliraat yuarutaitnek, aren tamaa-i tamana nallunritelqa ayagmek.",
        "translation": "But, you know, they'd [sing] Yup'ik dancing songs from legends, oh my, that's what I knew from the beginning."
    },
    "36": {
        "startTime": 254.735,
        "endTime": 263.365,
        "transcript": "Quliraat yuarutaitnek aturluteng yurarnaurtut cauyarluteng uksuarkami uksurpailgan.",
        "translation": "They'd sing songs from legends, Yup'ik dancing, and drumming at the cusp of fall before winter."
    },
    "37": {
        "startTime": 263.373,
        "endTime": 265.383,
        "transcript": "Tua-i-am piciryaraqluku yuut.",
        "translation": "It was the people's tradition."
    },
    "38": {
        "startTime": 265.39,
        "endTime": 270.32,
        "transcript": "Tua-i-ll' uksum iluani nutaan kelegluteng yurarluteng tua-i.",
        "translation": "Then in the winter, they'd finally invite [other villages] and have a dance festival."
    },
    "39": {
        "startTime": 270.336,
        "endTime": 275.766,
        "transcript": "Pikangqerrucirmegcetun neqnek, neqnek tua-i.",
        "translation": "They'd [bring] as much food as they could."
    },
    "40": {
        "startTime": 275.865,
        "endTime": 281.165,
        "transcript": "Kass'at-llu piyaurcata cali Kass'artarnek-am cali pilangluteng-am tua-i.",
        "translation": "Then when the Caucasians came, they also started [giving and eating] Western things."
    },
    "41": {
        "startTime": 281.173,
        "endTime": 287.483,
        "transcript": "Tua-i tuaten pitullruut au͡gkut wii angullrenka, pilangeqarraallret-wa tua-i.",
        "translation": "That's what the ones I was born in time to see used to do, the ones who first started celebrating."
    },
    "42": {
        "startTime": 288.251,
        "endTime": 296.261,
        "transcript": "Uum-qaa yuum piciryaraa tayima wani piilnguq cikiqalaasqelluku pingqerrutacimitun",
        "translation": "This person's tradition of giving to one who doesn't have anything as much as they can"
    },
    "43": {
        "startTime": 297.754,
        "endTime": 307.954,
        "transcript": "Elpeci murilkengllerpeceńi-qaa ayuqngatlinia makut wani aipaimta piciryaraqluku cikiqengluteng wall'u-qaa qaill' tamana ayuqellinia?",
        "translation": "When you started becoming observant, does it seem the same as our counterparts' tradition of giving, or what is that like?"
    },
    "44": {
        "startTime": 309.538,
        "endTime": 316.188,
        "transcript": "Atra-llu, atra pitekluku-llu ukut iciw'-llu kingunrulriit",
        "translation": "And on account of one's namesake, you know, these next generations"
    },
    "45": {
        "startTime": 316.197,
        "endTime": 324.287,
        "transcript": "Taum ilairutmeng atranek atellget-am cali tauna tamana pitekluku cikiqatulliniluku tauna.",
        "translation": "Those who are named after their late relative, they'd also give them a gift for that reason."
    },
    "46": {
        "startTime": 324.29,
        "endTime": 326.91,
        "transcript": "Tuaten-am pitulliniluteng.",
        "translation": "They would do that."
    },
    "47": {
        "startTime": 327.186,
        "endTime": 329.116,
        "transcript": "Alussistuam nalkenrilengraaku?",
        "translation": "Even if it wasn't Christmas time?"
    },
    "48": {
        "startTime": 329.123,
        "endTime": 331.863,
        "transcript": "Yes, even if it wasn't [Christmas] time.",
        "translation": "Yes, even if it wasn't [Christmas] time."
    },
    "49": {
        "startTime": 332.661,
        "endTime": 343.581,
        "transcript": "Tua-i-llu-qaa qaillun pitariqerluten makut wani tuyut wall'u agayulirtet",
        "translation": "And so, how old were you when these lay pastors or priests"
    },
    "50": {
        "startTime": 344.081,
        "endTime": 348.581,
        "transcript": "Ayagcetat-wa qaillun pitariluten tekitelangellruat maavet?",
        "translation": "How old were you when these traveling priests starting arriving here?"
    },
    "51": {
        "startTime": 348.597,
        "endTime": 358.617,
        "transcript": "Ugkut ellangvikellrenka muragcaurrlua, napacaurrlua tuyumek cikiumallruut.",
        "translation": "Where I grew up downriver, when I started getting wood, getting trees, they were given a lay pastor."
    },
    "52": {
        "startTime": 358.626,
        "endTime": 364.236,
        "transcript": "Tua-i waten qallataqluni tauna qasgimi.",
        "translation": "[S]he would preach like this in the community house."
    },
    "53": {
        "startTime": 364.644,
        "endTime": 370.894,
        "transcript": "Qasgimi tua-i mat'umek Qaneryaramek qalartaqan tua-i niicugniaqluku tua-i.",
        "translation": "When [s]he spoke of this Bible in the community house, we'd listen."
    },
    "54": {
        "startTime": 372.311,
        "endTime": 378.961,
        "transcript": "Tua-i-ll' tamatum kinguakun tayima tua-i cayaurtengluta tua-i.",
        "translation": "Then after that, we started doing [various non-Yup'ik] things."
    },
    "55": {
        "startTime": 378.978,
        "endTime": 386.988,
        "transcript": "Au͡gna ak'allaq qaneryariurta cali tekicaurrluni, ak'allaq tua-i.",
        "translation": "That old preacher started arriving, an old person."
    },
    "56": {
        "startTime": 387.165,
        "endTime": 390.335,
        "transcript": "Pektesteńgullrungatelliniuq tauna Kass'aq.",
        "translation": "It seemed that Caucasian was sent all over."
    },
    "57": {
        "startTime": 390.343,
        "endTime": 394.193,
        "transcript": "Yaaqvarmiu amta-ll' tua-i Yugcetun qalartetuluni.",
        "translation": "[S]he was from far away yet spoke Yup'ik."
    },
    "58": {
        "startTime": 395.531,
        "endTime": 403.951,
        "transcript": "Maa-i wani nunat ilaitni, nunat ilaitni tegulluteng aternek cikirturilartut.",
        "translation": "Now in some villages, in some villages, they take names [at random] and give presents."
    },
    "59": {
        "startTime": 403.968,
        "endTime": 405.658,
        "transcript": "Tamaani-qaa [Alussistualallruut]?",
        "translation": "Back then, [would they have Christmas like that]?"
    },
    "60": {
        "startTime": 405.662,
        "endTime": 410.252,
        "transcript": "Waten piyuitellruut tuaten watqapik.",
        "translation": "They never did that at all."
    },
    "61": {
        "startTime": 410.268,
        "endTime": 413.438,
        "transcript": "Qangvaq piyaurtut waten.",
        "translation": "They've started doing this sometime ago."
    },
    "62": {
        "startTime": 414.364,
        "endTime": 419.014,
        "transcript": "Qangvarraq tua-i nutaan. Qangvarraq tua-i.",
        "translation": "It was only until recently. It was recent."
    },
    "63": {
        "startTime": 419.131,
        "endTime": 430.911,
        "transcript": "Tamakut-qaa tuyut tekitellriit agayuvigni, aren qasgimi-wa quyurtevkarluki-qaa qaillun Alussistuaq atulallruatgu?",
        "translation": "When those lay pastors came to the churches, I mean, would they gather people in the community house, and how did they celebrate Christmas?"
    },
    "64": {
        "startTime": 430.928,
        "endTime": 435.068,
        "transcript": "Alussistuaq tamakut atuqsaitaat.",
        "translation": "Those people didn't celebrate Christmas."
    },
    "65": {
        "startTime": 435.073,
        "endTime": 444.543,
        "transcript": "Allanret tekitellriit tau͡gaam uum tuyum tuanelnguum Alussistuaq-llu tua-i man'a aturyaurtelluku takurramni tua-i.",
        "translation": "But the guests that came, this lay pastor among them had us start celebrating Christmas in my short life [at the time]."
    },
    "66": {
        "startTime": 444.988,
        "endTime": 447.048,
        "transcript": "Qaillun aturcetaqluku?",
        "translation": "How did [s]he have you celebrate?"
    },
    "67": {
        "startTime": 447.055,
        "endTime": 456.805,
        "transcript": "Tua-i-wa aturcetaqluku waten Alussistuarcuutnek-llu iciw' tua-i atualuteng-llu piyaurrluteng Alussistuarcuutnek.",
        "translation": "[S]he had us start celebrating like this with Christmas [songs], you know, they started singing Christmas songs."
    },
    "68": {
        "startTime": 458.245,
        "endTime": 466.365,
        "transcript": "Tua-i tau͡gken carrluarnek tua-i cikiqaquuraulluteng tua-i. Tua-i carrluarnek tua-i cikiqaquuraulluteng.",
        "translation": "However, they would give each other little things. They'd give each other little things."
    },
    "69": {
        "startTime": 466.372,
        "endTime": 468.772,
        "transcript": "Nutaan piyaurrluteng takumni.",
        "translation": "They only started in my lifetime."
    },
    "70": {
        "startTime": 469.016,
        "endTime": 479.766,
        "transcript": "Elpesmi maa-i wani camek mat'umi allrakumi Allrakumi piyuutengqercit?",
        "translation": "So, what do you want for Christmas this year?"
    },
    "71": {
        "startTime": 479.779,
        "endTime": 482.719,
        "transcript": "Niicugnilriit niitevkarluki.",
        "translation": "Have those who are listening hear."
    },
    "72": {
        "startTime": 483.506,
        "endTime": 495.196,
        "transcript": "Tua-i una Jesus-aam yuurtellra niicimayuitelqa avani tua-i wangkuta, wangkuta pitekluta",
        "translation": "The birth of Jesus, that I didn't hear about a lot back then, for our sake"
    },
    "73": {
        "startTime": 495.201,
        "endTime": 504.621,
        "transcript": "Matuulliniuq: tua-i man'a tua-i tangrruunrilnguq man'a tua-i unguvavut man'a tua-i Anerneq Tanqilria man'a tua-i unguvavut.",
        "translation": "This is what it is: this, our unseen life, this Holy Spirit is our life."
    },
    "74": {
        "startTime": 504.635,
        "endTime": 510.485,
        "transcript": "Tamatuulliniuq. Waten-gguq ayuquq man'a: iciw' Agayun piniungami",
        "translation": "That's what it is. They say this is like this: you know, because God is powerful"
    },
    "75": {
        "startTime": 511.035,
        "endTime": 522.015,
        "transcript": "Iciw' tua-i man'a Qaneryaraq kemgurrluku, tangrruurrluku tangrruunrilnguq, niicimatuli tau͡gaam.",
        "translation": "You know, he made this Word flesh, made seen what was unseen, only heard of."
    },
    "76": {
        "startTime": 522.019,
        "endTime": 525.829,
        "transcript": "Tangrruurrluku kemgurrluku yuurtelluku.",
        "translation": "He made him seen, made flesh, and had him be born."
    },
    "77": {
        "startTime": 526.222,
        "endTime": 529.032,
        "transcript": "Tuaten-gguq yuurtellruuq Jesus-aaq.",
        "translation": "They say Jesus was born like that."
    },
    "78": {
        "startTime": 529.267,
        "endTime": 536.837,
        "transcript": "Yuurtelluku atiin. Tua-i maavet nunamun tunluku cikiutekluku. Tua-i cikiutnguluni.",
        "translation": "His father had him be born. He gave him as a gift to this world. He was a gift."
    },
    "79": {
        "startTime": 536.864,
        "endTime": 538.914,
        "transcript": "Piciuguq tua-i man'a.",
        "translation": "This is true."
    },
    "80": {
        "startTime": 539.219,
        "endTime": 548.139,
        "transcript": "Waten iciw'-am cali yuarutet iliitni waten qaneryarartangqellria: \"Tangvaglua ukveqiciu ciuniurluku-llu cikiuteka.\"",
        "translation": "Like this, you know, in one of the songs, there are lyrics like this: \"Look at me, believe and accept my gift.\""
    },
    "81": {
        "startTime": 549.686,
        "endTime": 560.576,
        "transcript": "Tua-i waten ciuniunritesteḿinun iciw' tua-i Jesus-aaq ciuniunritesteḿinun waten-am Qaneryarani qaneryarartangqertuq:",
        "translation": "To those who do not accept him like this, youo know, to those who don't accept Jesus, there is a verse in the Bible like this:"
    },
    "82": {
        "startTime": 560.918,
        "endTime": 569.638,
        "transcript": "\"He makes only those who believe in him worthy to become God's people, the ones who believe in his [Jesus'] name.\" There's a verse like this.",
        "translation": "\"He makes only those who believe in him worthy to become God's people, the ones who believe in his [Jesus'] name.\" There's a verse like this."
    },
    "83": {
        "startTime": 569.644,
        "endTime": 579.204,
        "transcript": "Tua-i tua-i-llu ciuniurteńi ciuniurteḿinun pulaluni unguviinun",
        "translation": "Then for those who accept him, he goes into their life"
    },
    "84": {
        "startTime": 579.212,
        "endTime": 583.772,
        "transcript": "Ciuniuqani-w' tau͡gaam, piciuliuni tau͡gaam pikuni ciuniuqani.",
        "translation": "Only if [s]he accepts him, only if [s]he accepts him in earnest."
    },
    "85": {
        "startTime": 583.788,
        "endTime": 588.608,
        "transcript": "Tua-i-ll' taumun yugmun anirturilriarurrluni. Anirturteńgurrluni tua-i.",
        "translation": "Then he becomes a savior to that person. He becomes a savior."
    },
    "86": {
        "startTime": 588.61,
        "endTime": 594.58,
        "transcript": "Tau͡gken ciuniuqsaitesteḿinun anirturilriarurteksaunani taumun yugmun.",
        "translation": "However, to one who hasn't accepted him, he doesn't become a savior to that person."
    },
    "87": {
        "startTime": 594.815,
        "endTime": 600.785,
        "transcript": "Tua-i-llu waten ayuqelliniluni, waten-am qaneryarartangqertuq cali tayima:",
        "translation": "Then it's like this, there's also a verse like this:"
    },
    "88": {
        "startTime": 600.79,
        "endTime": 607.68,
        "transcript": "\"Kenkekenka inerqularanka anucimircetaarluki-llu. Taumek tengruluci umyualinqigci.",
        "translation": "\"I admonish those whom I love and chastise them. For that reason, enthusiastically repent."
    },
    "89": {
        "startTime": 607.689,
        "endTime": 611.459,
        "transcript": "\"Tangerrluku-llu nangerngaunga amigmi tukriarlua-llu.",
        "translation": "\"And look, I stand at the door and knock."
    },
    "90": {
        "startTime": 611.462,
        "endTime": 622.082,
        "transcript": "\"Yuum-llu erinaka niiskuniu amik-llu ikirrluku itervikciqaqa nerellgutekluku-llu elliin-llu wiinga.\" Tuaten-am qaneryarartangqertuq.",
        "translation": "\"If a person hears my voice and opens the door, I will go in and eat with them, and them with me.\" There's a verse like that."
    },
    "91": {
        "startTime": 622.177,
        "endTime": 629.147,
        "transcript": "Tua-i-llu yuum ciuniuqsailkuniu cailkamceciiqellinia anirturteksaguteksaunaku.",
        "translation": "Then if a person doesn't welcome him, he will leave them on on wayside without having become their savior."
    },
    "92": {
        "startTime": 629.149,
        "endTime": 631.169,
        "transcript": "Tuaten ayuqelliniuq.",
        "translation": "That's what it's like."
    },
    "93": {
        "startTime": 632.367,
        "endTime": 644.217,
        "transcript": "Tua-ll' au͡gna Agayutem-wa tua-i elpengcautii qanrutkeqeryugyaaqluku waten. Erinaka-w' tua-i saagartesqumayaaqluku.",
        "translation": "Then I want to talk about God's advice like this. I want my voice to spread."
    },
    "94": {
        "startTime": 644.222,
        "endTime": 653.184,
        "transcript": "Yuk waten au͡g'acurlakuni, waniwa-llam niitellriakut akwaugaq Kuigglugmi-gguq qama-i ilangartut.",
        "translation": "If a person passes away in sin, and now, we heard yesterday that someone passed away upriver in Kwethluk."
    },
    "95": {
        "startTime": 653.198,
        "endTime": 657.898,
        "transcript": "Tua-i-llam tua-i au͡gna cali-am waken qanelria waten qanerluni:",
        "translation": "Then that person from here also said this:"
    },
    "96": {
        "startTime": 659.298,
        "endTime": 666.667,
        "transcript": "\"Ellminek yuulriamek ellminek-llu tuqulriamek ilaitukut. Tau͡gaam yuullemteńi Atanermun yuugukut.\"",
        "translation": "\"There is none among us who lives by themself or dies by themself. But as we live, we live for the Lord.\""
    },
    "97": {
        "startTime": 666.675,
        "endTime": 675.405,
        "transcript": "Maa-i ukvelriim qaneryarartaa waten qanerluni: \"Atanermun yuugukut. Tuqukumta-llu Atanermun tuquciqukut.\"",
        "translation": "The believers' creed says this: \"We live for the Lord. And when we die, we will die for the Lord.\""
    },
    "98": {
        "startTime": 676.426,
        "endTime": 687.616,
        "transcript": "Taumek yuungramta wall'u tuqungramta Atanrem pikaakut. Tua-i ukvelriit tamaa-i qanrutkumallrat piciuluni-llu. Piciugarkauluni.",
        "translation": "That's why whether we live or die, we are the Lord's. That's what believers have said, and it's true. It must be true."
    },
    "99": {
        "startTime": 687.623,
        "endTime": 691.633,
        "transcript": "Tau͡gken piciunrilnguut aturngaitaat tamana.",
        "translation": "However, those who aren't true won't experience that."
    },
    "100": {
        "startTime": 692.261,
        "endTime": 700.281,
        "transcript": "Piciunrilkuni yuk tuquciquq tua-i-ll' unguvii pellucurlagluni.",
        "translation": "If a person isn't true, they will die, then their life will pass in misfortune."
    },
    "101": {
        "startTime": 702.006,
        "endTime": 704.866,
        "transcript": "Tua-i tau͡gaam kenermetarkauluni.",
        "translation": "Instead, [s]he will be in fire."
    },
    "102": {
        "startTime": 708.345,
        "endTime": 717.632,
        "transcript": "Au͡gna tua-i yugnun erinaka-w' tua-i saagarrluku cali-ll' aipaimteńun makunun erinaka [saagarrluku].",
        "translation": "I spread my voice about that to the people, and [I spread] my voice to our counterparts here."
    },
    "103": {
        "startTime": 717.64,
        "endTime": 725.55,
        "transcript": "Aipartek umyuaqelaryaaqaqa uumirpak ak'a una qanrutkeqeryugyaaqluku tau͡gaam takaqlutek nalluyuqlutek.",
        "translation": "I've been thinking of one of you lately wanting to speak of this, but I was uncomfortable and intimidated by you."
    },
    "104": {
        "startTime": 725.566,
        "endTime": 730.826,
        "transcript": "Tua-i-ll' airpartek umyuaqelaryaaqluku mumigteqaasqelluku qanelqa.",
        "translation": "Then I thought that one of you would translate what I said."
    },
    "105": {
        "startTime": 731.167,
        "endTime": 736.137,
        "transcript": "Yuk au͡g'acurlakuni, man'a unguvani pellucurlakuniu",
        "translation": "If a person passes away in sin, lives this life unacceptably"
    },
    "106": {
        "startTime": 736.993,
        "endTime": 746.793,
        "transcript": "Tua-i tau͡gaam nanvamun ek'arkauluni akwarpak akwanun tua-i kenermetlerkaminun pilliqetataunani.",
        "translation": "Instead, [s]he will go into the lake forever, to be in fire forever in the utmost suffering."
    },
    "107": {
        "startTime": 746.799,
        "endTime": 752.079,
        "transcript": "Man'a unguvavut tua-i arenqiiryarai-llu arenqiirturyarai amllerrsaaqut.",
        "translation": "There are many ways to resolve our lives."
    },
    "108": {
        "startTime": 752.081,
        "endTime": 756.841,
        "transcript": "Tua-i tau͡gaam yugmun waten maantenriqan qama-i niitukut.",
        "translation": "But when a person is no longer here, we've heard [of one] upriver."
    },
    "109": {
        "startTime": 756.858,
        "endTime": 759.628,
        "transcript": "Tua-i-llam taumi kep'uq tua-i.",
        "translation": "Then at that time, [the life] stops."
    },
    "110": {
        "startTime": 761.334,
        "endTime": 766.014,
        "transcript": "Iciw' tua-i arenqiirtuumarmi-w' tua-i.",
        "translation": "You know, with whatever resolution [that life] had."
    },
    "111": {
        "startTime": 767.018,
        "endTime": 768.118,
        "transcript": "Kitak'...",
        "translation": "So now..."
    },
    "112": {
        "startTime": 769.244,
        "endTime": 771.974,
        "transcript": "Kitak' atam una...",
        "translation": "So then this..."
    },
    "113": {
        "startTime": 778.038,
        "endTime": 787.878,
        "transcript": "Waten tang umyuaqa ayuqsaaqellria: aiparpetegnun imna-ll' Aqum'aq-llu qanelqa Kass'atun mumigartesqumayaaqluku.",
        "translation": "You see, this is my thought: that either you or Aqum'aq would translate what I said into English."
    },
    "114": {
        "startTime": 787.879,
        "endTime": 792.889,
        "transcript": "Tua-i elluarrluteng pillerkaat elpekesqumayaaqluku.",
        "translation": "I want them to understand how they could [live] well."
    },
    "115": {
        "startTime": 794.868,
        "endTime": 796.188,
        "transcript": "Ataki.",
        "translation": "Let's see."
    },
    "116": {
        "startTime": 796.196,
        "endTime": 801.056,
        "transcript": "Man'a wani calivigput-am piciurkiutengqertuq waten...",
        "translation": "Our workplace here has a policy like this..."
    },
    "117": {
        "startTime": 801.061,
        "endTime": 810.111,
        "transcript": "Maa-i umyuaqutmek assilriamek tuyuqerkut qanrulluta umyuarpenek iciw' Alussistuaqegcisqelluta.",
        "translation": "Now, wish us good tidings, tell us of your thoughts, you know, wishing us a Merry Christmas."
    },
    "118": {
        "startTime": 810.126,
        "endTime": 820.486,
        "transcript": "Ii-i, tua-ll' waniwa qanqauteknauqa canun imkunun niicugnistengqerrarkaukuma.",
        "translation": "Okay, so let me talk about it now if I have some of those people to listen to me."
    },
    "119": {
        "startTime": 820.84,
        "endTime": 826.57,
        "transcript": "Jesus-aam yuurtellra atam Agayutem... tua-i-q' waniwa? Waniwa-q' tua-i?",
        "translation": "Jesus' birth, you see, God... is it going now? Is it going now?"
    },
    "120": {
        "startTime": 826.58,
        "endTime": 827.29,
        "transcript": "Yaa.",
        "translation": "Yes."
    },
    "121": {
        "startTime": 827.422,
        "endTime": 837.172,
        "transcript": "Atam Agayutem kenkiin nunam yuinek, ellarpiin yuinek kenkitacian angtataitetacianek",
        "translation": "You see, God's love fo the people of the land, how there is nothing greater than his love for the people of the world"
    },
    "122": {
        "startTime": 837.184,
        "endTime": 844.114,
        "transcript": "Waten ayuqelliniuq Jesus-aaq una, waten Qaneryaranek qanrutkumauq waten qanerluni:",
        "translation": "This is what Jesus is like, it is told like this in the Bible saying this:"
    },
    "123": {
        "startTime": 844.123,
        "endTime": 852.453,
        "transcript": "\"Nutemtellrani Qaneryaraq uitallruuq, Qaneryaraq-llu Agayutmi uitallruuq, Qaneryaraq-llu Agayutnguluni.\"",
        "translation": "\"The Word was always there, and the Word was in God, and the Word was God.\""
    },
    "124": {
        "startTime": 852.63,
        "endTime": 859.37,
        "transcript": "Atam waten ayuqellinilria: ava-i qanelria Qaneryaraq nutemtellranek, ayagneranek qanerpek'nani.",
        "translation": "Look, it's like this: it just said when when the Word has always been, not talking about its beginning."
    },
    "125": {
        "startTime": 859.379,
        "endTime": 868.729,
        "transcript": "Atam Agayutem kenkiin angtataitetaciani tua-i waten, waten ayuqelliniluni, kitak' atam taringluku:",
        "translation": "Look, how there is nothing greater than God's love, it's like this, now understand it:"
    },
    "126": {
        "startTime": 869.676,
        "endTime": 876.996,
        "transcript": "Tuani-gguq atam taum tanqia mat'um tanqian, tanqia anaggluku tanqingqertuq.",
        "translation": "It says that there, you see, it's light has a greater light than the light here."
    },
    "127": {
        "startTime": 877.004,
        "endTime": 884.774,
        "transcript": "Cali-llu taukuk atam iluani eluciq angnirluni nunaniq tua-i tau͡gaam camek avuunani.",
        "translation": "Also, inside those is a shape that is happy and joyful but without anything added."
    },
    "128": {
        "startTime": 884.785,
        "endTime": 891.915,
        "transcript": "Tua-lli-wa cali waten yuarutetangqellria, yuarutni qaneryarartangqelalria:",
        "translation": "Furthermore, there's also a song like this, there are lyrics in a song:"
    },
    "129": {
        "startTime": 891.919,
        "endTime": 898.369,
        "transcript": "Jesus-aaq-gguq agallrunrilkan tamarmi yuum yuucia tamaumayartuq.",
        "translation": "It said that had Jesus not been hung, every person's life would be lost."
    },
    "130": {
        "startTime": 898.373,
        "endTime": 905.893,
        "transcript": "Tua-i-ll' Jesus-aaq atrallruan waten ayuqelliniluni: atam kenkiin angtataitetacia.",
        "translation": "Then when Jesus came down, it was like this: look how there is nothing greater than his love."
    },
    "131": {
        "startTime": 906.207,
        "endTime": 916.444,
        "transcript": "Atam tanqik, tanqik nuniq, camna-wa tan'geq nangteqnaq tuqu, pellernaq.",
        "translation": "Look at the light, the wonderful light, and the darkness below, miserable death, repulsive."
    },
    "132": {
        "startTime": 916.666,
        "endTime": 924.846,
        "transcript": "Tua-lli-wa kenkitacirmitun Agayutem tuarpiaq tauna Jesus-aaq tuarpiaq tamaa iivkarluku.",
        "translation": "Furthermore, with the extent of God's love, it truly seemed that he sent Jesus down right away."
    },
    "133": {
        "startTime": 924.85,
        "endTime": 932.32,
        "transcript": "Tuarpiaq nunam yuini yaaqliurrluku, nunam yui ukaqliurrluki kenkiin angtataitetacia.",
        "translation": "It truly seems that he put [Jesus] over from the people of the land, put the people of the land closer to him with the greatest love."
    },
    "134": {
        "startTime": 933.218,
        "endTime": 942.188,
        "transcript": "Ak'akika tua-i mat'umek au͡gna assikaqa-llu. Cangakenritaqa tua-i.",
        "translation": "With so much for this, I like that one too. I don't mind it."
    },
    "135": {
        "startTime": 942.35,
        "endTime": 952.52,
        "transcript": "Tua-i-ll' pitsaqa'artevkenaku au͡gna qanruteksugyaaqelqa pitsaqa'artevkenaku pillerkangqerqan pisqumakuviu-llu nutaan piyarluku.",
        "translation": "Then should there be time for me to talk about what I wanted to, and should you want me to, I would."
    },
    "136": {
        "startTime": 952.577,
        "endTime": 960.357,
        "transcript": "Kitak' Merry Christmas-aaqerkut wangkuta tangvalriani maa-i.",
        "translation": "Please wish a Merry Christmas to us who are watching now."
    },
    "137": {
        "startTime": 960.361,
        "endTime": 966.531,
        "transcript": "Tua-i niitellriani tua-i tamarpeci tua-i waniw' hello-ramci tua-i Merry Chrismas-aarluci.",
        "translation": "All of you who are listening now, I say hello and wish you a Merry Christmas."
    },
    "138": {
        "startTime": 966.893,
        "endTime": 967.973,
        "transcript": "Quyana.",
        "translation": "Thank you."
    },
    "139": {
        "startTime": 967.988,
        "endTime": 968.748,
        "transcript": "Yaa.",
        "translation": "You're welcome."
    }
};